"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MaterialPointData_size, _MaterialPointData_sizeAttenuation;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialPointData = void 0;
const IMaterialAbstractData_1 = require("../../interfaces/data/material/IMaterialAbstractData");
const AbstractMaterialData_1 = require("./AbstractMaterialData");
class MaterialPointData extends AbstractMaterialData_1.AbstractMaterialData {
    // #endregion Properties (2)
    // #region Constructors (1)
    /**
     * Creates a material data object.
     *
     * @param _attributes the attributes of the material
     * @param id the id
     */
    constructor(properties, id, version) {
        super(properties, id, version);
        // #region Properties (2)
        _MaterialPointData_size.set(this, undefined);
        _MaterialPointData_sizeAttenuation.set(this, undefined);
        if (!properties)
            return;
        if (properties.size !== undefined)
            this.size = properties.size;
        if (properties.sizeAttenuation !== undefined)
            this.sizeAttenuation = properties.sizeAttenuation;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (4)
    get size() {
        return __classPrivateFieldGet(this, _MaterialPointData_size, "f");
    }
    set size(value) {
        __classPrivateFieldSet(this, _MaterialPointData_size, value, "f");
    }
    get sizeAttenuation() {
        return __classPrivateFieldGet(this, _MaterialPointData_sizeAttenuation, "f");
    }
    set sizeAttenuation(value) {
        __classPrivateFieldSet(this, _MaterialPointData_sizeAttenuation, value, "f");
    }
    // #endregion Public Accessors (4)
    // #region Public Methods (3)
    clone() {
        return new MaterialPointData({
            alphaMap: this.alphaMap,
            alphaCutoff: this.alphaCutoff,
            alphaMode: this.alphaMode,
            aoMap: this.aoMap,
            aoMapIntensity: this.aoMapIntensity,
            bumpMap: this.bumpMap,
            bumpScale: this.bumpScale,
            color: this.color,
            depthTest: this.depthTest,
            depthWrite: this.depthWrite,
            emissiveMap: this.emissiveMap,
            emissiveness: this.emissiveness,
            shading: this.shading,
            map: this.map,
            name: this.name,
            normalMap: this.normalMap,
            normalScale: this.normalScale,
            opacity: this.opacity,
            side: this.side,
            transparent: this.transparent,
            size: this.size,
            sizeAttenuation: this.sizeAttenuation,
        }, this.id, this.version);
    }
    copy(source) {
        this.alphaCutoff = source.alphaCutoff;
        this.alphaMap = source.alphaMap;
        this.alphaMode = source.alphaMode;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.color = source.color;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.emissiveMap = source.emissiveMap;
        this.emissiveness = source.emissiveness;
        this.materialOutput = source.materialOutput;
        this.map = source.map;
        this.normalMap = source.normalMap;
        this.normalScale = source.normalScale;
        this.opacity = source.opacity;
        this.shading = source.shading;
        this.side = source.side;
        this.transparent = source.transparent;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
    }
    reset() {
        this.alphaCutoff = 0;
        this.alphaMap = undefined;
        this.alphaMode = IMaterialAbstractData_1.MATERIAL_ALPHA.OPAQUE;
        this.aoMap = undefined;
        this.aoMapIntensity = 1.0;
        this.bumpMap = undefined;
        this.bumpScale = 1.0;
        this.color = "#ffffff";
        this.depthTest = undefined;
        this.depthWrite = undefined;
        this.emissiveMap = undefined;
        this.emissiveness = "#000000";
        this.materialOutput = false;
        this.map = undefined;
        this.normalMap = undefined;
        this.normalScale = 1.0;
        this.opacity = 1.0;
        this.shading = IMaterialAbstractData_1.MATERIAL_SHADING.SMOOTH;
        this.side = IMaterialAbstractData_1.MATERIAL_SIDE.DOUBLE;
        this.transparent = undefined;
        this.size = undefined;
        this.sizeAttenuation = undefined;
    }
}
exports.MaterialPointData = MaterialPointData;
_MaterialPointData_size = new WeakMap(), _MaterialPointData_sizeAttenuation = new WeakMap();
//# sourceMappingURL=MaterialPointData.js.map